import { useMutation } from '@apollo/client';
import { Button, Card, DatePicker, Form, notification } from 'antd';
import dayjs from 'dayjs';
import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import CustomInput from './CustomComponents/CustomInput';
import { CREATE_PROCEEDING_MUTATION } from './ProceedingFormConstants';

export const ProceedingForm = () => {
  const [form] = Form.useForm();
  const navigate = useNavigate();

  const today = new Date();

  const [createNewProceeding, { loading: creating, error: creationError, data: newProceeding }] =
    useMutation(CREATE_PROCEEDING_MUTATION, { onError: () => {} });

  const onFinish = async (values: any) => {
    await createNewProceeding({
      variables: {
        input: {
          chcReceivedDate: values.chiefDate
            ? dayjs(values.chiefDate).format('YYYY-MM-DD')
            : undefined,
          referralDate: values.applicationDate
            ? dayjs(values.applicationDate).format('YYYY-MM-DD')
            : undefined, 
          description: values.description,
        },
      },
    });
  };

  useEffect(() => {
    if (creationError) {
      notification.error({
        message: 'Error in creating Proceeding',
      });
    }
    if (newProceeding) {
      notification.success({
        message: 'Success',
        description: `Proceeding ${newProceeding.createProceeding.proceedingId} has been created.`,
      });
      form.resetFields();
      navigate(`/hearing/proceeding/${newProceeding.createProceeding?.proceedingId}?tab=2`);
    }
  }, [creationError, newProceeding]);

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'flex-start',
        minHeight: '80vh',
        marginTop: '-60px',
      }}
    >
      <Card
        title={<span className="highlighted-title">Create Proceeding</span>}
        style={{
          width: 640,
          border: '1px solid rgba(211, 211, 211, 0.5)', 
          boxShadow: '0 0 10px rgba(211, 211, 211, 0.4)', 
          borderRadius: '4px', 
        }}
        className="card"
      >
        <Form form={form} layout="vertical" onFinish={onFinish}>
          <Form.Item name="applicationDate" label="Date File Referred for Hearing">
            <DatePicker
              style={{ width: '100%' }}
              disabledDate={(current) => current.isAfter(today)}
            />
          </Form.Item>
          <Form.Item
            name="chiefDate"
            label="Date Chief Hearing Commissioner Received Panel Request"
          >
            <DatePicker
              style={{ width: '100%' }}
              disabledDate={(current) => current.isAfter(today)}
            />
          </Form.Item>
          <Form.Item
            name="description"
            label="Description"
            rules={[
              {
                required: true,
                message: 'Please enter the description of the proceeding',
                whitespace: true,
              },
            ]}
          >
            <CustomInput showInput={true}></CustomInput>
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit" loading={creating}>
              Submit
            </Button>
            <Link to="/hearing">
              <Button style={{ marginLeft: 8 }}>Cancel</Button>
            </Link>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default ProceedingForm;
